import { FETCH_DELIVERABLES, UPDATE_DELIVERABLES, UPDATE_DELIVERABLE, DELETE_DELIVERABLE } from '../actions/deliverable';

export default function (state = [], action) {

    switch (action.type) {
        case UPDATE_DELIVERABLES:
            return [action.payload, ...state];

        case UPDATE_DELIVERABLE:
            let newState = [...state];
            let objIndex = newState.findIndex((obj => obj.key == action.payload.key));
            newState.splice(objIndex, 1, action.payload);
            return newState;

        case FETCH_DELIVERABLES:
            return action.payload;

        case DELETE_DELIVERABLE:
            const deletedState = state.filter(val => val.key !== action.payload.key);
            return deletedState;
    }

    return state;
}